import { supabase } from '@/config/supabase';
import { formatNumber } from '@/utils/format';

export class LeaderboardPanel {
  private container: HTMLElement;
  private listEl: HTMLElement;

  constructor(parent: HTMLElement) {
    this.container = document.createElement('div');
    this.container.id = 'leaderboard-panel';
    this.container.className = 'game-panel';

    this.container.innerHTML = `
      <div class="game-panel-header">
        <div class="game-panel-title">🏆 LEADERBOARD</div>
        <button class="game-panel-close">&times;</button>
      </div>
    `;

    this.listEl = document.createElement('div');
    this.container.appendChild(this.listEl);
    this.container.querySelector('.game-panel-close')!.addEventListener('click', () => this.hide());

    this.listEl.addEventListener('click', (e) => {
      const target = (e.target as HTMLElement).closest('.leaderboard-name') as HTMLElement | null;
      if (target?.dataset['playerId']) {
        window.location.hash = `/profile/${target.dataset['playerId']}`;
      }
    });

    parent.appendChild(this.container);
  }

  async refresh(): Promise<void> {
    this.listEl.innerHTML = '<div style="color:#666; text-align:center;">Loading...</div>';

    const { data, error } = await supabase
      .from('leaderboard')
      .select('*')
      .limit(20);

    if (error || !data) {
      this.listEl.innerHTML = '<div style="color:#e74c3c; text-align:center;">Error loading</div>';
      return;
    }

    this.listEl.innerHTML = '';
    for (const p of data) {
      const row = document.createElement('div');
      row.style.cssText = `
        display: flex; justify-content: space-between;
        padding: 4px 0; border-bottom: 1px solid #1a1a2e; font-size: 12px;
      `;
      const rankSpan = document.createElement('span');
      rankSpan.style.color = '#888';
      rankSpan.textContent = `#${p.rank}`;

      const nameSpan = document.createElement('span');
      nameSpan.className = 'leaderboard-name';
      nameSpan.dataset['playerId'] = p.id;
      nameSpan.style.cssText = 'color:var(--gold); flex:1; margin-left:8px; cursor:pointer; text-decoration:underline;';
      nameSpan.textContent = p.username;

      const prodSpan = document.createElement('span');
      prodSpan.style.color = 'var(--green)';
      prodSpan.textContent = `+${formatNumber(p.production_rate)}/s`;

      row.appendChild(rankSpan);
      row.appendChild(nameSpan);
      row.appendChild(prodSpan);
      this.listEl.appendChild(row);
    }

    if (data.length === 0) {
      this.listEl.innerHTML = '<div style="color:#666; text-align:center;">No players yet</div>';
    }
  }

  show(): void {
    this.container.style.display = 'block';
    this.refresh();
  }

  hide(): void {
    this.container.style.display = 'none';
  }

  toggle(): void {
    if (this.container.style.display === 'none') {
      this.show();
    } else {
      this.hide();
    }
  }

  destroy(): void {
    this.container.remove();
  }
}
